// *******************************************
// **** Cashback Section Routes/Paths ****
// *******************************************

export const URL_SCORECARD_LIST_TOP = "/cb_score"
export const URL_SCORECARD_LIST_BOTTOM = "/cb_score_2"
export const URL_ABV_COMPARISON_DATA = "/cb_abv_comp"
export const URL_CASHBACK_INFLUENCE_DATA = "/cashback_influence"
export const URL_CASHBACK_REDEMPTION_DATA = "/cashback_redeemption_chart"
